export default __webpack_public_path__ + "static/media/Logo.15607c65.png";